import * as React from "react";

import { isFixedContentWidth } from "../../searchdiscover/toggles";
import { Grid } from "react-bootstrap";

type Props = {
    children?: React.ReactNode;
};

export function FixedWidthWrapper(props: Props) {
    return !isFixedContentWidth() ? (
        <Grid fluid>{props.children}</Grid>
    ) : (
        <React.Fragment>{props.children}</React.Fragment>
    );
}
